import { CssBaseline, ThemeProvider } from "@mui/material";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { SnackbarProvider, useSnackbar } from "notistack";
import { useEffect } from "react";
import { RouterProvider, createBrowserRouter } from "react-router";
import { configureClient } from "./api/client";
import { AuthProvider } from "./auth/AuthContext";
import { routes } from "./app/routes";
import { theme } from "./app/theme";

const router = createBrowserRouter(routes);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // The admin screens are read-then-act; a stale list after a mutation is
      // the main failure mode, so refetch on focus stays on.
      retry: 1,
      staleTime: 30_000,
    },
  },
});

/**
 * Hands the api module its toast and its "session is gone" callback. Lives in
 * its own component so it runs inside the SnackbarProvider.
 */
function ClientWiring() {
  const { enqueueSnackbar } = useSnackbar();
  useEffect(() => {
    configureClient({
      notify: (message) => enqueueSnackbar(message, { variant: "error" }),
      onSessionLost: () => {
        window.location.assign("/login");
      },
    });
  }, [enqueueSnackbar]);
  return null;
}

export function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <SnackbarProvider maxSnack={3} anchorOrigin={{ vertical: "top", horizontal: "right" }}>
        <ClientWiring />
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <RouterProvider router={router} />
          </AuthProvider>
        </QueryClientProvider>
      </SnackbarProvider>
    </ThemeProvider>
  );
}
